<template>
    <div class="table-action-buttons">
        <i v-if="this.$can('update-trajectories')" class="fa fa-clone fa-lg pointer" @click="duplicate" :title="uLang('app.duplicate_type', { type: lang('app.action') })"></i>
        <i v-if="this.$can('update-trajectories')" class="fa fa-edit fa-lg pointer" @click="edit" :title="uLang('app.edit_type', { type: lang('app.action') })"></i>
        <i v-if="this.$can('delete-trajectories')" class="fa fa-trash fa-lg pointer" @click="remove" :title="uLang('app.delete_type', { type: lang('app.action') })"></i>
    </div>
</template>

<script>
    import { DestroyAlert, SuccessAlert, ErrorAlert } from '~/Swals'

    export default {
        name: 'actions',
        props: ['data', 'index'],


        methods: {
            remove() {
                new DestroyAlert({ entity: this.lang('app.action') }).show().then(async () => {
                    this.destroy()
                });
            },

            edit() {
                this.$router.push({ name: 'admin.trajectory_projects.trajectories.milestones.actions.edit', params: { projectId: this.data.milestone.trajectory.trajectory_project_id, trajectoryId: this.data.milestone.trajectory_id, milestoneId: this.data.milestone_id, id: this.data.id }})
            },

            destroy() {
                window.axios.delete(
                    route('trajectory-projects.trajectories.milestones.actions.destroy', {
                        trajectory_project: this.data.milestone.trajectory.trajectory_project_id,
                        trajectory: this.data.milestone.trajectory_id,
                        milestone: this.data.milestone_id,
                        action: this.data.id
                    })).then(({ data }) => {
                        new SuccessAlert({title: this.data.name, text: this.uLang('app.entity_removed', { entity: this.lang('app.action') })}).show();
                        vue.$emit('reloadTable');
                    }).catch(({ response }) => {
                        new ErrorAlert({text: response.data.message}).show();
                });
            },

            async duplicate() {
                let {data} = await window.axios.post(route('trajectory-projects.trajectories.milestones.actions.duplicate', { trajectory_project: this.data.milestone.trajectory.trajectory_project_id, trajectory: this.data.milestone.trajectory_id, milestone: this.data.milestone_id, action: this.data.id }));

                this.$router.push({ name: 'admin.trajectory_projects.trajectories.milestones.actions.edit', params: { projectId: this.data.milestone.trajectory.trajectory_project_id, trajectoryId: this.data.milestone.trajectory_id, milestoneId: this.data.milestone_id, id: data.id }});
            },
        }
    }
</script>

<style lang="scss" scoped>
</style>